import { useCallback } from 'react';
import mixpanel from 'mixpanel-browser';
import i18n from 'i18next';

import { Popup, Tooltip } from 'web-components';
import { Flex, Text, SVG, icons } from 'web-styled';
import config from 'web-config';

import * as S from './styled';

type Props = {
  isOpen: boolean;
  isPro: boolean;
  namespace: any;
  onToggle: () => void;
  onClose: () => void;
};

const HelpDropdown = ({
  isOpen,
  isPro,
  namespace,
  onToggle,
  onClose,
}: Props) => {
  const handleToggle = useCallback(() => {
    onToggle();
    if (!isOpen) {
      mixpanel.track('Clicked help button');
    }
  }, [isOpen, onToggle]);

  const getSupportUrl = () => (
    (isPro || namespace.symbol === 'gymcloud' || namespace.symbol === 'ideafit')
      ? config.urls.freshdesk
      : config.urls.support
  );

  return (
    <S.Dropdown data-tour="tour__help" isOpen={isOpen}>
      <Popup
        isOpen={isOpen}
        trigger={(
          <S.Trigger isOpen={isOpen}>
            <Tooltip
              body={i18n.t('tooltip.main.header.help')}
              isOpen={isOpen ? false : undefined}
              positions={['left']}
            >
              <Flex column align="center" spacing={5}>
                <S.HelpIcon />
                <Text
                  color={isOpen ? '#ffffff' : '#757575'}
                  size="10px"
                  lineHeight="11px"
                  whiteSpace="pre-line"
                >
                  Help
                </Text>
              </Flex>
            </Tooltip>
          </S.Trigger>
        )}
        setPopupVisible={handleToggle}
        onClickOutside={onClose}
      >
        <S.Actions mr={76}>
          <S.Action
            as="a"
            rel="noopener noreferrer"
            href="https://gymcloud.freshdesk.com/support/tickets/new"
            target="_blank"
            align="center"
          >
            <SVG.PencilIcon size={14} />
            <span>Give Feedback</span>
          </S.Action>
          <S.Action
            as="a"
            rel="noopener noreferrer"
            href={getSupportUrl()}
            target="_blank"
            align="center"
          >
            <Flex flex="0 0 15px">
              <img
                src={icons.helpcenter}
                alt="Help Center"
                width="13px"
              />
            </Flex>
            <span>Go to Support Portal</span>
          </S.Action>
        </S.Actions>
      </Popup>
    </S.Dropdown>
  );
};

export default HelpDropdown;
